module.exports = __webpack_public_path__ + "images/help/video-preview-calendar-1698dc15e26ace1a5ce9af0facf830bf.png";